export const FETCH_BIRTHDAY_REQUEST = "FETCH_BIRTHDAY_REQUEST";
export const FETCH_BIRTHDAY_SUCCESS = "FETCH_BIRTHDAY_SUCCESS";
export const FETCH_BIRTHDAY_FAILURE = "FETCH_BIRTHDAY_FAILURE";
